import { AppState } from '@/redux/helper';
import { selectAbility } from '@/shared/entitlements';

import { SpeedyFlowUser } from './types';

/**
 * Flatten the redux user into the shape the pure layer takes.
 *
 * Shared by the two places that ask an entitlement question — deciding whether to open a flow, and
 * deciding afterwards whether the gate is finally satisfied — so the two cannot answer differently
 * for the same visitor.
 *
 * Note `subscription`: the API sends `subscriptionStatus` and `setUserData` renames it on the way
 * in, so anything reading a raw API response must use the other name (see ADR 0003).
 */
const selectSpeedyFlowUser = (state: AppState): SpeedyFlowUser => {
  const { user } = state;
  return {
    isLoggedIn: !!user.logged,
    isRealEmail: !!user.isRealEmail,
    persona: user.persona ?? undefined,
    can: selectAbility(state).can,
  };
};

export default selectSpeedyFlowUser;
